import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INewsCreateUpdateItem, INewsItem } from '../interfaces/news/INews';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}News/`;

  private readonly httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  public createNews(news: INewsCreateUpdateItem): Observable<INewsItem> {
    return this.http.post<INewsItem>(`${this.baseUrl}Create`, news, this.httpOptions);
  }

  public getSingleNews(id: number): Observable<INewsCreateUpdateItem> {
    return this.http.get<INewsCreateUpdateItem>(`${this.baseUrl}GetSingle/${id}`);
  }

  public getAllNews(): Observable<INewsCreateUpdateItem[]> {
    return this.http.get<INewsCreateUpdateItem[]>(`${this.baseUrl}GetAll`);
  }

  public getAllActiveNews(): Observable<INewsItem[]> {
    return this.http.get<INewsItem[]>(`${this.baseUrl}GetAllActive`);
  }
}
